<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Reclamation'
});
</script>
<template>
  <ka-container
    code="reclamation"
    :data="page.$info.reclamation">
    <ka-text code="titre">
      <h1 v-html="t('reclamation.titre.value', `Contactez-nous, nous sommes là pour vous aider !`)" />
    </ka-text>
    <!-- Ecrivez-nous Formulaire -->
    <ka-container code="ecrivez-nous-formulaire">
      <!-- Ecrivez nous -->
      <ka-container code="ecrivez-nous">
        <ka-text code="sous-titre">
          <span v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.sousTitre.value', `Écrivez-nous !`)" />
        </ka-text>
        <ka-text code="vous-preferez-nous">
          <span v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.vousPreferezNous.value', `Vous préférez nous écrire ? Pas de souci ! Nous vous répondrons le plus vite possible. Si vous préférez être contacté par téléphone, n’oubliez pas de cocher la case ci-dessous et de renseigner votre numéro !`)" />
        </ka-text>
        <!-- Conteneur 2 -->
        <ka-container code="conteneur-2">
          <ka-icon
            code="icone"
            value="i-fa-solid:landmark" />
          <ka-text code="des-formation-action">
            <h3 v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.conteneur2.desFormationAction.value', `Des formation-action 100% financées.`)" />
          </ka-text>
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-1">
          <ka-icon
            code="icon-1"
            value="i-fa-solid:certificate" />
          <ka-text code="le-modele-de-formation">
            <h3 v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.container1.leModeleDeFormation.value', `LE modèle de formation pratique par excellence.`)" />
          </ka-text>
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-2">
          <ka-icon
            code="icon-2"
            value="i-fa-solid:hands-helping" />
          <ka-text code="des-experts-qui-matchent">
            <h3 v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.container2.desExpertsQuiMatchent.value', `Des experts qui matchent avec vos projets`)" />
            <template #xs>
              <h3 v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.container2.desExpertsQuiMatchent.xs.value', `Des experts qui matchent avec vos projets.`)" />
            </template>
          </ka-text>
        </ka-container>
        <!-- Conteneur 2 -->
        <ka-container code="container-3">
          <ka-icon
            code="icon-3"
            value="i-fa-solid:hand-holding-heart" />
          <ka-text code="une-equipe-devouee">
            <h3 v-html="t('reclamation.ecrivezNousFormulaire.ecrivezNous.container3.uneEquipeDevouee.value', `Une équipe dévouée toujours à votre écoute. `)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <ka-separator code="separator" />
      <!-- Formulaire -->
      <ka-container code="formulaire">
        <ka-iframe
          code="iframe"
          :options="{
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            }
          }"
          value="https://share.hsforms.com/1iY0i3JaaTKOycR2CY0WLiw2xvix" />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { reclamation } from './store'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p25')
const appData = appDataStore()
const page = reclamation()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
